import _ from 'lodash';

import { TaskStatus, TaskStatusLabel } from 'constants/tasks';
import { replaceValuesInsideCurlyBrackets } from 'utils/string';

const formatTaskName = ({ name, dynamicFieldOptions }) =>
  replaceValuesInsideCurlyBrackets({
    string: name ?? '',
    options: dynamicFieldOptions,
    keyToReplace: 'value',
    keyToReplaceWith: 'name',
  });

export const getLinkableTaskOptions = ({ tasks, linkedTaskIds, dynamicFieldOptions }) =>
  _.sortBy(
    _.values(tasks)
      .filter(
        task =>
          task?.taskId &&
          task.status !== TaskStatus.CANCELED &&
          !linkedTaskIds.includes(task.taskId),
      )
      .map(task => ({
        id: task.taskId,
        name: `${formatTaskName({ name: task.name, dynamicFieldOptions })} (${
          TaskStatusLabel[task.status] ?? task.status
        })`,
      })),
    ({ name }) => name.toLowerCase(),
  );

export const getLinkedTasksMessage = ({ count, conditionNumber }) =>
  `${count} ${count === 1 ? 'task' : 'tasks'} linked to condition #${conditionNumber}.`;
